export const PathUtils = {
  isSameLocationPath(urlPath: string, pathAgainst: string): boolean {
    return urlPath === pathAgainst;
  },
};
